<template>
  <router-view></router-view>
</template>

<script>
    export default {
        name: "WorkOrderHome"
    }
</script>

<style scoped>

</style>
